<template>
	<div class="sale-base">
		<router-view/>
	</div>
</template>

<script>
export default {
  name: 'SaleBase',
	components: {
	},
  data () {
    return {
    }
  },
	methods: {
	}
}
</script>

<style lang="scss" scoped>
</style>
